import { Box, IconButton, Paper, Typography } from '@mui/material';
import { BillableMaterial } from '../types';
import { Add } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import MaterialsOverviewItem from './MaterialsOverviewItem';

interface MaterialsOverviewProps {
  materials: BillableMaterial[];
  selectedMaterialId?: string;
  dirtyMaterialId?: string;
  onSelectMaterial: (bm: BillableMaterial) => void;
  onAddNewMaterial: () => void;
  onDuplicateMaterial: (id: string) => void;
  onDeleteMaterial: (id: string) => void;
}

export default function MaterialsOverview({
  materials,
  selectedMaterialId,
  dirtyMaterialId,
  onSelectMaterial,
  onAddNewMaterial,
  onDuplicateMaterial,
  onDeleteMaterial,
}: MaterialsOverviewProps) {
  const { t } = useTranslation();

  return (
    <Paper
      elevation={8}
      sx={{
        flex: 1,
        borderRadius: '10px',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'auto',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          backgroundColor: '#f8fafc',
          padding: '0.5em 1em',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Typography variant='h6'>{t('billableMaterial.count', { count: materials.length })}</Typography>
        <IconButton onClick={onAddNewMaterial}>
          <Add />
        </IconButton>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flex: 1,
          flexDirection: 'column',
        }}
      >
        {materials?.length === 0 ? (
          <Typography variant='body2' sx={{ padding: '1em', color: 'text.secondary' }}>
            {t('billableMaterial.noneConfigured')}
          </Typography>
        ) : (
          materials.map((material) => (
            <MaterialsOverviewItem
              key={material.id}
              material={material}
              isSelected={selectedMaterialId === material.id}
              isDirty={dirtyMaterialId === material.id}
              onSelect={onSelectMaterial}
              onDuplicate={onDuplicateMaterial}
              onDelete={onDeleteMaterial}
            />
          ))
        )}
      </Box>
    </Paper>
  );
}
